import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-overcast.svg";
import * as styles from "./Icon.module.scss";

type WeatherOvercastProps = React.SVGProps<SVGSVGElement>;

export const WeatherOvercast = ({ className, ...props }: WeatherOvercastProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
